exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#RegistrationForm[data-v-07bb2108] {\n\twidth: 100%;\n}\n", ""]);

// exports
